import { callMethodOnKeydown, isTyping } from '../helpers'
import { viewport } from '../map_state/viewport'

class FullscreenTool {
  constructor () {
    this.element = document.getElementById('mct-fullscreen')
    this.container = this.element.closest("[data-controller='mct']")
    this.bindEvents()
  }

  bindEvents () {
    this.toggleFullscreen = this.toggleFullscreen.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.onFullscreenChange = this.onFullscreenChange.bind(this)

    this.element.addEventListener('click', this.toggleFullscreen)
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('fullscreenchange', this.onFullscreenChange)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.toggleFullscreen)
    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('fullscreenchange', this.onFullscreenChange)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'f') callMethodOnKeydown(e.target, this.toggleFullscreen)
  }

  onFullscreenChange () {
    const isFullscreen = document.fullscreenElement === this.container

    this.element.classList.toggle('selected', isFullscreen)
    viewport.setContainerSize(isFullscreen)
  }

  async toggleFullscreen () {
    if (document.fullscreenElement === this.container) {
      await document.exitFullscreen()
    } else {
      viewport.windowHeight = window.innerHeight
      await this.container.requestFullscreen()
    }
  }
}

export let fullscreenTool = null

export function initFullscreenTool () {
  fullscreenTool = new FullscreenTool()
  return fullscreenTool
}
